import { useEffect, useState } from "react";
import CustomValuesHook from "../../Hooks/customValuesHook";
import Header from "./header";

import { DateToPersianNumber, ToPersianNumber } from "../../functions";
import DetectedSensitiveWordType from "./select/enum/type";
import DetectedSensitiveWordState from "./select/enum/states";
import TypeOfActivity from "./select/typeActivity";
import StatusClient from "./select/statusClient";
import ListActivity from "./listActivity";
import { ErrorToast, InfoToast } from "../../shared";
import { getDetectedSensitiveWordLog } from "../../api/requestAxios/getDetectedSensitiveWordLog";
import { IData, IDataTabel } from "../../api/modelAPI/detectedSensitiveWordLog";
import CustomerFilter from "./select/customerFilter";

type Props = {
  setUserId: Function;
  userId: string;
  login:any,
  token:string
};

const SensitiveActivity = ({ setUserId, userId,login,token }: Props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IDataTabel>({ data: [] });

  const [states, setStates] = CustomValuesHook({
    pageSize: 10,
    pageNumber: 1,
    disablePaging: false,
    sortText: "",
    whereConditionText: "",
  });

  const [select, setSelect] = CustomValuesHook({
    typeActivity: DetectedSensitiveWordType?.IvrSetting.toString(),
    statusCustomer: DetectedSensitiveWordState?.New.toString(),
    customerId: "",
  });

  useEffect(() => {
    let whereCondition = `Type=${select?.typeActivity} && State=${select?.statusCustomer}`;
    getLog(whereCondition);
  }, []);

  const getLog = async (whereCondition: string) => {
    setLoading(true);
    try {
      let tmpStates = { ...states };
      tmpStates.whereConditionText = whereCondition;
      const response = await getDetectedSensitiveWordLog(tmpStates);
      setLoading(false);
      let tmp = [...response?.data?.data];
      tmp?.forEach((item: IData, index: number) => {
        item.row = ToPersianNumber(index + 1);
      });
      setData({ data: [...tmp] });
    } catch (error) {
      setLoading(false);
      ErrorToast(error);
    }
  };

  const search = (e: any) => {
    e.preventDefault();
    let whereConditionText = "";
    if (select?.statusCustomer && select?.typeActivity)
      whereConditionText = `Type=${select?.typeActivity} && State=${select?.statusCustomer}`;
    else if (select?.statusCustomer)
      whereConditionText = `State=${select?.statusCustomer}`;

    if (select?.customerId) {
      whereConditionText =
        whereConditionText + ` && customerId=\"${select?.customerId}\" `;
    }
    getLog(whereConditionText);
  };

  return (
    <div>
      <main className="sensitive-activity">
        <div className="top-margin"></div>
        <div className="user-info-container user-docs-container">
          <div className="d-flex justify-content-between align-items-center  sensitive-activity-header mb-2">
            <Header />
            <div className="d-flex justify-content-between align-items-center sensitive-activity-select ">
              <CustomerFilter setSelect={setSelect} select={select}/>
              <TypeOfActivity setSelect={setSelect} />
              <StatusClient setSelect={setSelect} select={select}/>
              <button
                disabled={loading}
                onClick={(e) => search(e)}
                className="button-searc-activity-list"
              >
                {loading ? (
                  <div
                    className="spinner-border"
                    role="status"
                    aria-hidden="true"
                  ></div>
                ) : (
                  "جستجو"
                )}
              </button>
            </div>
          </div>
          <hr />
          <div>
            <ListActivity
              data={data}
              loading={loading}
              select={select}
              getLog={getLog}
              token={token}
              login={login}
              userId={userId}
              setUserId={setUserId}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default SensitiveActivity;
